import React, { useState, useEffect, useRef } from "react";
import FormHeader from "../../../Components/formHeaders/formheaders";
import Back from "../../../Components/back/back";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import "../../../css/loader.css";
import { FaPlus, FaTrash } from "react-icons/fa"; // Import the plus icon from react-icons
import config from "../../../Context/Config";
import AssignmentRelease from "../../../Components/assignmentRelease/assignmentRelease";
import FinancialPolicy from "../../../Components/financialPolicy/financialPolicy";
import ImageConsent from "../../../Components/imageConsent/imageConsent";
import PrivacyConsent from "../../../Components/privacyPolicy/privacyPolicy";
import Rocket from "../../../Components/rocket/rocket";
import Writing from '../../../Components/typewriter/typewriter';
import NextBtnLoader from "../../../Components/loader/loader";
import FormInput from "../../../Components/formInput/formInput";
import SelectInput from "../../../Components/selectInput/select";
import Signature from "../../../Components/signature/signature";
import TextInput from "../../../Components/textInput/textInput";
import BackgruseRedirectIfNotLoggedIn from '../../../Components/redirect/redirect';
import { checkTokenAndNavigate } from "../../../Utils/login";
import { getCityStateFromZip } from "../../../Utils/zip";
import MedicalPortalAccess from "../../../Components/selectInput/portal";
import DynamicCheckbox from "../../../Components/selectInput/consent";
import { languageOptions, genderOptions, emergencyRelationshipOptions, ethnicityOptions, raceOptions, maritalOptions } from '../../../Utils/Options';
import { formattingDate } from "../../../Utils/formatDate";
import { handleFamilyContentChanges } from "../../../Utils/familyMembers";
import DobInput from "../../../Components/dobPicker/dobInput";
import Paragraph from "../../../Components/paragraph/paragrah";
import DisabledTextBox from "../../../Components/textInput/disabledText";
import { showAlertAndNavigate } from "../../../Utils/swal";


const PatientRegistrationPageForm = () => {
  const [nextLoader, setNextLoader] = useState(false);
  const location = useLocation();
  const { openedViaLogin } = location.state || {};
  BackgruseRedirectIfNotLoggedIn(openedViaLogin, 50, "/context-not-found");
  const [isUploading, setIsUploading] = useState(false);
  const navigate = useNavigate();
  const [pageTitle, setPageTitle] = useState("");
  const [subPageTitle, setSubPageTitle] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const currentDate = new Date();
  const [isDisabled, setIsDisabled] = useState(false);
  const [showPatientSignature, setShowPatientSignature] = useState(false);
  const [showPatientSignaturePage4, setShowPatientSignaturePage4] = useState(false);
  const [showPatientSignaturePage5, setShowPatientSignaturePage5] = useState(false);
  const [showPatientSignaturePage6, setShowPatientSignaturePage6] = useState(false);
  const [isLoading4, setIsLoading4] = useState(false);

  // Enhanced image loading with better error handling
  const formatDate = (date) => {
    try {
      const formattedDate = formattingDate(date);
      return formattedDate
    } catch (err) {
      console.error('Error formatting date:', err.message);
    }
  };
  const formattedDate = formatDate(currentDate); // Formats current date
  const taskRunRef = useRef(false);
  // Formatted current date using the formatDate function
  const [isNext, setIsNext] = useState(false);
  const [invalidFields, setInvalidFields] = useState([]);
  const [age, setAge] = useState("");
  const [signatures, setSignatures] = useState({
    responsiblePersonSignature: "",
    patientSignature: "",
    doctorSignature: "",
  });
  const canvasRefs = {
    responsiblePersonSignature: useRef(null),
    patientSignature: useRef(null),
    doctorSignature: useRef(null),
  };
  const [isEditing, setIsEditing] = useState({});
  const [PatientRegistrationFormData, setPatientRegistrationFormData] =
    useState({
      firstName: "",
      lastName: "",
      address: "",
      city: "",
      state: "",
      zip: "",
      ssn: "",
      gender: "",
      dob: "",
      consentToText: "",
      portal: "",
      originalPortal: "",
      email: "",
      homephone: "",
      cellphone: "",
      language: "",
      ethnicity: "",
      maritalStatus: "",
      referredBy: "",
      familyDoctor: "",
      parentspouse: "",
      employee: "",
      employeeEmail: "",
      workphone: "",
      employeeExtn: "1",
      emergencyName: "",
      emergencyRelationship: "",
      emergencyPhone: "",
      patientSignature: "",
      responsiblePersonSignature: "",
      responsiblePersonRelationship: "",
      doctorSignature: "",
      familyMembers: [{ name: "", relationship: "", dob: "", mobile_number: "" }],
      symptoms: {
        "Blurred Vision": null,
        "Chest Pain": null,
        "Diarrhea": null,
        "Fatigue": null,
        "Headache": null,
        "Dizziness": null,
        "Pain in Joints": null,
        "Paralysis of Extremities": null,
        "Shortness of Breath": null,
        "Runny Nose": null,
        "Sore Throat/Cough": null,
        "Bloody Stools": null,
        "Fever": null,
        "Nausea/Vomiting": null,
        "Pain with Urination": null,
        "Frequent Urination": null,
        "Rash": null,
        "Sudden Vision Loss": null,
      },
      medicalHistory: {
        Blindness: null,
        Cataract: null,
        Glaucoma: null,
        "Macular Degeneration": null,
        "Retinal Detachment": null,
        Arthritis: null,
        Cancer: null,
        Diabetes: null,
        "Cardiac/Vascular Disease": null,
        Stroke: null,
        "Thyroid Disease": null,
        "High Blood Pressure": null,
        "Kidney Stones": null,
        "Stomach Ulcer": null,
        "Asthma/Emphysema": null,
        "AIDS/HIV": null,
      },
      familyDiseases: {
        "Blindness": { hasDisease: null, relationship: null },
        "Cataract": { hasDisease: null, relationship: null },
        "Glaucoma": { hasDisease: null, relationship: null },
        "Macular Degeneration": { hasDisease: null, relationship: null },
        "Retinal Detachment": { hasDisease: null, relationship: null },
        "Arthritis": { hasDisease: null, relationship: null },
        "Cancer": { hasDisease: null, relationship: null },
        "Diabetes": { hasDisease: null, relationship: null },
        "Heart Attacks": { hasDisease: null, relationship: null },
        "High Blood Pressure": { hasDisease: null, relationship: null },
        "Kidney Disease": { hasDisease: null, relationship: null },
        "Stroke": { hasDisease: null, relationship: null },
        "Thyroid Disease": { hasDisease: null, relationship: null }
      },
      reviewed: "",
      smoker: "",
      packsPerDay: "",
      smokedInPast: "",
      drinksAlcohol: "",
      glassesPerDay: "",
      isMarried: "",
      doYouDrive: "",
      medication: "",
      allergies: "",
      imageConsent: "",
      other_important_information: ""
    });


  // Function to handle API call
  const runTask = async () => {
    // console.log("runTask started....")
    setIsLoading4(true);
    if (taskRunRef.current) return; // Prevent running if task has already been executed
    taskRunRef.current = true;

    try {
      const response = await fetch(`${config.API_BASE_URL}/token_pat_data`, {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          Authorization: config.accessToken || ""

        }
      });

      if (response.ok) {
        let data = await response.json();
        const dbData = data?.db_data ?? {};
        setPatientRegistrationFormData(prevState => ({
          ...prevState, // Retain existing fields
          firstName: data['firstname'] || "",
          lastName: data['lastname'] || "",
          address: data['address1'] || "",
          gender: data['sex'] || "",
          zip: data['zip'] || "",
          city: data['city'] || "",
          state: data['state'] || "",
          cellphone: (data['mobilephone'] || "").toString().trim(),
          language: data['language6392code'] || "",
          email: data['email'] || "",
          race: data?.race?.[0] || "",
          emergencyName: data['contactname'] || "",
          emergencyRelationship: data['contactrelationship'] || "",
          emergencyPhone: (data['contactmobilephone'] || "").toString().trim(),
          ssn: data['ssn'] || "",
          dob: data['dob'] || prevState.dob, // Preserve existing value if not in `data`
          ethnicity: (data?.ethnicitycodes?.[0]) || prevState.ethnicity,
          familyMembers: data['family_data'] || prevState.familyMembers,
          consentToText: data['consenttotext'] || prevState.consentToText,
          employee: dbData.employee ?? "",
          workphone: (data['workphone'] || "").toString().trim(),
          maritalStatus: data['maritalstatus'] || "",
          portal: data['portalstatus']['registered'] || "",
          originalPortal: data['portalstatus']['registered'],
          employeeExtn: "1",
          homephone: (data['homephone'] || "").toString().trim(),
          referredBy: dbData.referred_by ?? "",
          familyDoctor: dbData.family_doctor ?? "",
          parentspouse: dbData.parentspouse ?? "",
          employeeEmail: dbData.employee_email ?? "",
          patientSignature: dbData.patient_signature ?? "",
          responsiblePersonSignature: dbData.responsible_person_signature ?? "",
          responsiblePersonRelationship: dbData.responsible_person_relationship ?? "",
          // doctorSignature: dbData.doctor_signature ?? "",
          symptoms: dbData.symptoms ?? prevState.symptoms,
          medicalHistory: dbData.medical_history ?? prevState.medicalHistory,
          familyDiseases: dbData.family_diseases ?? prevState.familyDiseases,
          smoker: dbData.smoker ?? "",
          packsPerDay: dbData.packs_per_day ?? "",
          smokedInPast: dbData.smoked_in_past ?? "",
          drinksAlcohol: dbData.drinks_alcohol ?? "",
          glassesPerDay: dbData.glasses_per_day ?? "",
          isMarried: dbData.is_married ?? "",
          doYouDrive: dbData.do_you_drive ?? "",
          medication: dbData.medication ?? "",
          surgeries: dbData.surgeries ?? "",
          other_important_information: dbData.other_important_information ?? "",
          allergies: dbData.allergies ?? "",
          imageConsent: dbData.image_consent ?? "",
        }));

        setSignatures((prev) => ({
          ...prev,
          patientSignature: dbData.patient_signature ?? "",
        }));
        setSignatures((prev) => ({
          ...prev,
          responsiblePersonSignature: dbData.responsible_person_signature ?? "",
        }));

      }
      else {
        showAlertAndNavigate(
          "warning",
          "Unauthorized",
          "Your session expired. Redirecting to login...",
          config.token
        );
      }
    } finally {
      // Reset loading state
      setIsLoading4(false);
    }
  };

  useEffect(() => {
    if (openedViaLogin && !taskRunRef.current) {
      checkTokenAndNavigate(runTask, navigate);
    }
  }, [openedViaLogin]);


  const handlePacksChange = (e) => {
    setPatientRegistrationFormData((prev) => ({
      ...prev,
      packsPerDay: e.target.value, // Assign the value directly
    }));
  };

  const handleCheckChange = (key, value) => {
    setPatientRegistrationFormData((prev) => ({
      ...prev,
      [key]: value, // Dynamically set the key with the value
    }));
  };

  const handleImageConsentChange = (option) => {
    setPatientRegistrationFormData((prev) => ({
      ...prev,
      imageConsent: option,
    }));
  };

  const validateFamilyMembers = (familyMembers) => {
    const isValidPhone = (value, country = "US") => {
      const parsed = parsePhoneNumberFromString(value, country);
      return parsed?.isValid() || false;
    };
    const dobRegex = /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/\d{4}$/;
    let msg = "";
    // If only one family member, check separately
    if (familyMembers.length === 1) {
      const member = familyMembers[0];

      const allEmpty = Object.values(member).every(
        (value) => !value?.toString().trim()
      );
      if (allEmpty) {
        return;
      }
      const isDobValid = dobRegex.test(member.dob) && new Date(member.dob) <= new Date();


      // Validate missing values (excluding phone)
      if (
        Object.entries(member).some(
          ([key, value]) =>
            key !== "mobile_number" &&
            (value === null ||
              value === undefined ||
              value.toString().trim() === "")
        )
      ) {
        msg += `Missing values in family member: ${JSON.stringify(member)}. `;


      }
      if (!isDobValid) {
        msg += "Invalid DOB format. Please use MM/DD/YYYY.\n";
      }
      // Validate phone number separately
      if (!isValidPhone(member.mobile_number)) {
        msg = `Invalid phone number. ` + msg;
      }

      return msg || null; // Return message if there's an error, otherwise return null
    }

    // If multiple family members, validate all
    for (let i = 0; i < familyMembers.length; i++) {
      const member = familyMembers[i];
      const isDobValid = dobRegex.test(member.dob) && new Date(member.dob) <= new Date();

      // Check missing values (excluding phone)
      if (
        Object.entries(member).some(
          ([key, value]) =>
            key !== "mobile_number" &&
            (value === null ||
              value === undefined ||
              value.toString().trim() === "")
        )
      ) {
        msg += `Missing values in family member at index ${i}: ${JSON.stringify(
          member
        )}`;
      }

      // Validate phone number separately

      if (!isValidPhone(member.mobile_number)) {
        msg += "Invalid phone number.\n";
      }

      if (!isDobValid) {
        msg += "Invalid DOB format. Please use MM/DD/YYYY.\n";
      }
      return msg || null;
    }

    return null; // All validations passed
  };

  const handleAddMember = () => {
    const lastMember =
      PatientRegistrationFormData.familyMembers[
      PatientRegistrationFormData.familyMembers.length - 1
      ];
    const filledFields = [
      lastMember.name,
      lastMember.relationship,
      lastMember.dob,
      lastMember.mobile_number,
    ].filter((field) => field !== "" && field !== null);

    console.log(filledFields);
    // Check for phone number validity
    const parsedPhone = parsePhoneNumberFromString(lastMember.mobile_number, "US");
    const dobRegex = /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/\d{4}$/;
    const isPhoneValid =
      lastMember.mobile_number && parsedPhone && parsedPhone.isValid();
    const isDobValid = dobRegex.test(lastMember.dob) && new Date(lastMember.dob) <= new Date();

    // If only one field is filled or the phone number is invalid, show a single alert
    if (filledFields.length < 4 || !isPhoneValid || !isDobValid) {
      let alertMessage =
        "Please fill in all fields for the current family member before adding another.";
      if (!isPhoneValid || !isDobValid) {
        alertMessage += " Additionally, please provide:";

        if (!isPhoneValid) {
          alertMessage += " a valid phone number";
        }

        if (!isPhoneValid && !isDobValid) {
          alertMessage += " and";
        }

        if (!isDobValid) {
          alertMessage += " a valid date of birth";
        }

        alertMessage += ".";
      }
      Swal.fire({
        title: "Missing/Invalid Fields",
        text: alertMessage,
        icon: "warning",
        confirmButtonText: "OK",
        allowOutsideClick: false,
      });
      return; // Prevent adding a new member
    }
    setPatientRegistrationFormData({
      ...PatientRegistrationFormData,
      familyMembers: [
        ...PatientRegistrationFormData.familyMembers,
        { name: "", relationship: "", dob: "", mobile_number: "" },
      ],
    });
  };


  const toggleEditMode = (type, editMode) => {
    clearSignature(type);
    setIsEditing((prev) => ({
      ...prev,
      [type]: editMode,
    }));
  };

  const updateSignatureData = (type) => {
    const canvas = canvasRefs[type].current;
    if (canvas) {
      const dataUrl = canvas.toDataURL(0.3);
      setSignatures((prev) => ({
        ...prev,
        [type]: dataUrl,
      }));
      setPatientRegistrationFormData((prev) => ({
        ...prev,
        [type]: dataUrl, // Temporarily store in original format
      }));
    }
  };

  const clearSignature = (type) => {
    const canvas = canvasRefs[type]?.current;

    if (canvas) {
      // Clear the canvas if it exists
      canvas.clear();
    }

    // Clear the signature data from states
    setSignatures((prev) => ({
      ...prev,
      [type]: "",
    }));

    setPatientRegistrationFormData((prev) => ({
      ...prev,
      [type]: "", // Remove signature from form data
    }));

    // Optionally, exit edit mode if in edit mode
    setIsEditing((prev) => ({
      ...prev,
      [type]: false,
    }));
  };

  const handleGlassesChange = (e) => {
    setPatientRegistrationFormData((prev) => ({
      ...prev,
      glassesPerDay: e.target.value, // Assign the value directly
    }));
  };

  const handleCheckboxChange = (category, item, value) => {
    setPatientRegistrationFormData((prevState) => ({
      ...prevState,
      [category]: {
        ...prevState[category],
        [item]: value,
      },
    }));
  };

  const handleZipSearch = async () => {
    const zip = PatientRegistrationFormData.zip;
    const result = await getCityStateFromZip(zip);
    if (result) {
      setPatientRegistrationFormData({
        ...PatientRegistrationFormData,
        city: result.city,
        state: result.state,
      });
    } else {
      setPatientRegistrationFormData({
        ...PatientRegistrationFormData,
        city: '',
        state: '',
      });
    }
  }


  const handleRelationshipChange = (section, disease, value) => {
    setPatientRegistrationFormData((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [disease]: {
          ...prev[section][disease],
          relationship: value
        }
      }
    }));
  };

  const handleCheckboxChangeForFamily = (section, disease, value) => {
    setPatientRegistrationFormData((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [disease]: {
          ...prev[section][disease],
          hasDisease: value
        }
      }
    }));
  };

  const handlePatientRegistration = async (e) => {
    e.preventDefault();

    if (currentPage === 7) {
      const validate = validateForm(currentPage);
      if (!validate) {
        return;
      }
    }

    try {
      const response = await fetch(`${config.API_BASE_URL}/update_db`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: config.accessToken || ""
        },
        body: JSON.stringify({
          form: PatientRegistrationFormData
        }),
      });
      if (response.ok) {
        console.log("Demographics updated successfully.");
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Demographics updated successfully.",
          confirmButtonText: "Close",
          allowOutsideClick: false,
        }).then(() => {
          navigate("/form-submission-success", { state: { openedViaLogin: true } });
        });
      }
      else {
        showAlertAndNavigate(
          "warning",
          "Unauthorized",
          "Your session expired. Redirecting to login...",
          config.token
        );

      }
    }
    catch (error) {
      console.error("Error updating patient registration data:", error);

    }
  };

  useEffect(() => {
    // Define titles for different pages
    const titles = {
      0: "Patient Details",
      1: "Patient Details",
      2: "Assignment And Release",
      3: "Medical History Questionnaire",
      4: "Medical History Questionnaire",
      5: "Acknowledgement of Receipt of Notice of Privacy Practices",
      6: "Consent For The Release Of Images For Retina Specialty Institute Photographer Equipment Certification And Research Purposes",
      7: "Financial Responsibility Consent",
      8: "Freeflow Consent",
    };

    // Set the title based on the current page
    setSubPageTitle(titles[currentPage]);
  }, [currentPage, setSubPageTitle]); // Run this effect whenever `currentPage` or `setTitle` changes

  useEffect(() => {
    // Set the title based on the current page
    setPageTitle("New Patient Registration Form");
  }, [setPageTitle]); // Run this effect whenever `currentPage` or `setTitle` changes

  const ButtonGroup = ({
    isDisabled,
    currentPage,
    handleEdit,
    handleNext,
    handleSubmit,
    handlePatientRegistration,
  }) => {
    const buttonClass =
      "px-6 py-3 bg-sky-600 text-white rounded-lg shadow-md hover:bg-sky-700 focus:outline-none focus:ring-2 focus:ring-sky-500 focus:ring-opacity-50 transition-all";

    const shouldShowRegisterButton = currentPage === 7;
    // const shouldShowFinishButton = !(currentPage >= 0 && currentPage <= 6);

    return (
      <div className="flex justify-end space-x-2 p-5 pt-0">

        {shouldShowRegisterButton ? (
          <button onClick={handlePatientRegistration} className={buttonClass}>
            <i className="fas fa-user-plus mr-2"></i> Register Patient
          </button>
        ) : (
          <button
            type="button"
            onClick={handleNext}
            className={buttonClass}
            id="next"
          >
            <i className="fas fa-arrow-right mr-2"></i> Next
          </button>
        )}
      </div>
    )

  };

  const handlePortalChange = (e) => {
    const { id, value } = e.target;

    setPatientRegistrationFormData((prev) => ({
      ...prev,
      [id]: id === "portal" ? value === "true" : value,
    }));
  };

  const handleInputChange = (e) => {
    const { id, value } = e.target;

    setPatientRegistrationFormData((prev) => ({
      ...prev,
      [id]: value, // For other fields, update normally
    }));
  };

  const validatePage1 = () => {
    // Define validation patterns
    const PATTERNS = {
      ssn: /^\d{3}-\d{2}-\d{4}$|^\d{9}$/,
      email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
      phone: (value, country = "US") => {
        const parsed = parsePhoneNumberFromString(value, country);
        return parsed?.isValid() || false;
      },
    };

    // Define required fields
    const REQUIRED_FIELDS = [
      // { field: "email", label: "Email" },
      { field: "firstName", label: "First Name" },
      { field: "lastName", label: "Last Name" },
      { field: "address", label: "Address" },
      { field: "city", label: "City" },
      { field: "state", label: "State" },
      { field: "zip", label: "Zip" },
      { field: "dob", label: "Date of Birth" },
      { field: "gender", label: "Gender" },
    ];

    // Reset invalid fields
    setInvalidFields([]);
    const invalidFields = [];

    // Validate required fields
    REQUIRED_FIELDS.forEach(({ field, label }) => {
      const value = PatientRegistrationFormData[field];
      if (!String(value || "").trim()) {
        invalidFields.push(label);
      }
    });

    // Extract relevant data
    const {
      homephone,
      cellphone,
      ssn,
      email,
      portal,
      dob
    } = PatientRegistrationFormData;


    if (dob) {
      const dobRegex = /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/\d{4}$/;
      if (!dobRegex.test(dob)) {
        invalidFields.push("DOB");
      } else {
        const [month, day, year] = dob.split("/").map(Number);
        const dobDate = new Date(year, month - 1, day);
        const today = new Date();
        const minDate = new Date(today.getFullYear() - 125, today.getMonth(), today.getDate());

        if (dobDate > today || dobDate < minDate) {
          invalidFields.push("DOB");
        }
      }
    }

    // Validate Home Phone (if provided)
    if (homephone && !PATTERNS.phone(homephone)) {
      invalidFields.push("Home Phone");
    }

    // Validate Cell Phone
    if (!PATTERNS.phone(cellphone)) {
      invalidFields.push("Cell Phone");
    }

    // Validate email
    if (portal === true && (!email || !PATTERNS.email.test(email))) {
      invalidFields.push("Email");
    } else if (email && !PATTERNS.email.test(email)) {
      invalidFields.push("Email");
    }

    // Validate SSN (if provided)
    if (ssn && !PATTERNS.ssn.test(ssn)) {
      invalidFields.push("SSN");
    }

    // If there are invalid fields, show an alert
    if (invalidFields.length > 0) {
      setInvalidFields(invalidFields);
      Swal.fire({
        title: "Missing or Invalid Fields",
        text: `Please fill out or correct the following fields:\n- ${invalidFields.join(
          "\n- "
        )}`,
        icon: "warning",
        confirmButtonText: "OK",
        allowOutsideClick: false,
      });
      return false; // Indicate invalid form
    }
    return true; // Indicate valid form
  };

  const validatePage2 = () => {
    // Define validation patterns
    const PATTERNS = {
      email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
      phone: (value, country = "US") => {
        const parsed = parsePhoneNumberFromString(value, country);
        return parsed?.isValid() || false;
      },
    };

    const REQUIRED_FIELDS = [
      { field: "familyDoctor", label: "Family Doctor" },
      { field: "referredBy", label: "Referred By" }
    ];

    // Reset invalid fields
    setInvalidFields([]);
    const invalidFields = [];

    // Validate required fields
    REQUIRED_FIELDS.forEach(({ field, label }) => {
      if (!PatientRegistrationFormData[field]?.trim()) {
        invalidFields.push(label);
      }
    });

    // Emergency fields validation
    const {
      emergencyPhone,
      employeeEmail,
      emergencyName,
      emergencyRelationship,
      workphone,
      employee,
      responsiblePersonSignature,
    } = PatientRegistrationFormData;
    const emergencyFields = [
      { value: emergencyName, label: "Emergency Name" },
      { value: emergencyRelationship, label: "Emergency Relationship" },
      { value: emergencyPhone, label: "Emergency Phone" },
    ];

    const filledEmergencyFields = emergencyFields.filter(({ value }) =>
      value?.trim()
    ).length;
    if (
      filledEmergencyFields > 0 &&
      filledEmergencyFields < emergencyFields.length
    ) {
      emergencyFields.forEach(({ value, label }) => {
        if (!value?.trim()) invalidFields.push(label);
      });
    }

    if (age < 18 && !responsiblePersonSignature) {
      invalidFields.push("Responsible Person Signature");
    }

    const employeeFields = [
      // { value: employeeEmail, label: "Employee Mail" },
      { value: employee, label: "Employee Name" },
      { value: workphone, label: "Employee Phone" },
    ];

    const filledEmployeeFields = employeeFields.filter(({ value }) =>
      value?.trim()
    ).length;
    if (
      filledEmployeeFields > 0 &&
      filledEmployeeFields < employeeFields.length
    ) {
      employeeFields.forEach(({ value, label }) => {
        if (!value?.trim()) invalidFields.push(label);
      });
    }

    // Validate Emergency Phone
    if (workphone && !PATTERNS.phone(workphone)) {
      invalidFields.push("Employee Phone");
    }

    if (employeeEmail && !PATTERNS.email.test(employeeEmail)) {
      invalidFields.push("Employee Email");
    }

    // If there are invalid fields, show an alert
    if (invalidFields.length > 0) {
      setInvalidFields(invalidFields);

      Swal.fire({
        title: "Missing or Invalid Fields",
        text: `Please fill out or correct the following fields:\n- ${invalidFields.join(
          "\n- "
        )}`,
        icon: "warning",
        confirmButtonText: "OK",
        allowOutsideClick: false,
      });

      return false; // Indicate invalid form
    }
    return true; // Indicate valid form
  };

  const validatePage3 = () => {
    setInvalidFields([]); // Clear previously set invalid fields
    const missingFields = []; // Initialize missingFields array to track invalid fields

    const requiredFields = [];

    // If age is less than 18, add minorSignature to required fields
    if (age >= 18) {
      requiredFields.push({
        field: "patientSignature",
        label: "Patient's Signature",
      });
    } else {
      requiredFields.push({
        field: "responsiblePersonSignature",
        label: "Responsible Person's Signature",
      });
      requiredFields.push({
        field: "responsiblePersonRelationship",
        label: "Responsible Person's Relationship",
      });
    }


    // Check for missing required fields
    requiredFields.forEach(({ field, label }) => {
      if (!PatientRegistrationFormData[field]) {
        setInvalidFields((prev) => [...prev, field]);
        missingFields.push({ field, label });
      }
    });

    if (!showPatientSignature && age <= 18) {
      missingFields.push({ "Signature": "Agree and sign" });
    }

    // If any fields are invalid or missing, show alert and return false
    if (missingFields.length > 0) {
      // Show an alert with the missing fields
      Swal.fire({
        title: "Missing or Invalid Fields",
        text: `Please fill out or correct the following fields:\n- ${missingFields
          .map(({ label }) => label)
          .join("\n- ")}`,
        icon: "warning",
        allowOutsideClick: false,
      });
      return false;
    }

    // If no invalid or missing fields, clear invalidFields and return true
    setInvalidFields([]);
    return true; // Return true to indicate valid form
  };

  const validatePage5 = () => {
    setInvalidFields([]); // Clear previously set invalid fields
    const missingFields = []; // Initialize missingFields array to track invalid fields

    const requiredFields = [
      // { field: "doctorSignature", label: "Doctor's Signature" },
    ];


    if (PatientRegistrationFormData.smoker === true && PatientRegistrationFormData.packsPerDay === "") {
      requiredFields.push({
        field: "packsPerDay",
        label: "Mention number of packets",
      });
    }

    if (
      PatientRegistrationFormData.drinksAlcohol === true &&
      PatientRegistrationFormData.glassesPerDay === ""
    ) {
      requiredFields.push({
        field: "glassesPerDay",
        label: "Mention number of glasses",
      });
    }

    if (!showPatientSignaturePage4) {
      missingFields.push({
        field: "Signature",
        label: "Agree and sign"
      });
    }

    requiredFields.forEach(({ field, label }) => {
      if (!PatientRegistrationFormData[field]) {
        setInvalidFields((prev) => [...prev, field]);
        missingFields.push({ field, label });
      }
    });



    // If any fields are invalid or missing, show alert and return false
    if (missingFields.length > 0) {
      console.log(missingFields)
      // Show an alert with the missing fields
      Swal.fire({
        title: "Missing or Invalid Fields",
        text: `Please fill out or correct the following fields:\n- ${missingFields
          .map(({ label }) => label)
          .join("\n- ")}`,
        icon: "warning",
        allowOutsideClick: false,
      });

      return false;
    }

    // If no invalid or missing fields, clear invalidFields and return true
    setInvalidFields([]);
    return true;
  };

  const validatePage6 = () => {
    // Reset invalid fields
    setInvalidFields([]);
    const invalidFields = [];

    const result = validateFamilyMembers(
      PatientRegistrationFormData.familyMembers
    );
    if (result) {
      invalidFields.push(result);
    }
    if (!showPatientSignaturePage5) {
      invalidFields.push("Agree and Sign")
    }
    if (invalidFields.length > 0) {
      setInvalidFields(invalidFields);

      Swal.fire({
        title: "Missing or Invalid Fields",
        text: `Please fill out or correct the following fields:\n- ${invalidFields.join(
          "\n- "
        )}`,
        icon: "warning",
        confirmButtonText: "OK",
        allowOutsideClick: false,
      });

      return false; // Indicate invalid form
    }
    return true; // Indicate valid form
  };

  const validatePage7 = () => {
    setInvalidFields([]); // Clear previously set invalid fields
    const missingFields = []; // Initialize missingFields array to track invalid fields

    const requiredFields = [];
    if (PatientRegistrationFormData.imageConsent === "") {
      requiredFields.push({
        field: "imageConsent",
        label: "Either agree or disagree",
      });
    }

    requiredFields.forEach(({ field, label }) => {
      if (!PatientRegistrationFormData[field]) {
        setInvalidFields((prev) => [...prev, field]);
        missingFields.push({ field, label });
      }
    });
    // If any fields are invalid or missing, show alert and return false
    if (missingFields.length > 0) {
      // Show an alert with the missing fields
      Swal.fire({
        title: "Missing or Invalid Fields",
        text: `Please fill out or correct the following fields:\n- ${missingFields
          .map(({ label }) => label)
          .join("\n- ")}`,
        icon: "warning",
        allowOutsideClick: false,
      });

      return false;
    }

    // If no invalid or missing fields, clear invalidFields and return true
    setInvalidFields([]);
    return true;
  };

  const validatePage8 = () => {
    setInvalidFields([]); // Clear previously set invalid fields
    const missingFields = []; // Initialize missingFields array to track invalid fields

    const requiredFields = [];
    if (!showPatientSignaturePage6) {
      missingFields.push({
        field: "Signature",
        label: "Agree and sign",
      });
    }
    requiredFields.forEach(({ field, label }) => {
      missingFields.push({ field, label });
    });

    // If any fields are invalid or missing, show alert and return false
    if (missingFields.length > 0) {
      // Show an alert with the missing fields
      Swal.fire({
        title: "Missing or Invalid Fields",
        text: `Please fill out or correct the following fields:\n- ${missingFields
          .map(({ label }) => label)
          .join("\n- ")}`,
        icon: "warning",
        allowOutsideClick: false,
      });

      return false;
    }

    // If no invalid or missing fields, clear invalidFields and return true
    setInvalidFields([]);
    return true;
  };

  const validateForm = (page) => {
    switch (page) {
      case 0:
        return validatePage1();
      case 1:
        return validatePage2();
      case 2:
        return validatePage3();
      case 3:
        return true;
      case 4:
        return validatePage5();
      case 5:
        return validatePage6();
      case 6:
        return validatePage7();
      case 7:
        return validatePage8();
      default:
        return false;
    }
  };

  const handleSubmit = async (e) => {
    try {
      if (currentPage === 7) {
        const validate = validateForm(currentPage);
        if (!validate) {
          return;
        }
      }

    } finally {
      setIsNext(false);
    }

  };

  const handleNext = async (e) => {
    try {
      e.preventDefault();
      if (!validateForm(currentPage)) {
        return;
      } else {
        setIsNext(true);
        setNextLoader(true);
        setCurrentPage((prev) => prev + 1);
        console.log("Current Page:", PatientRegistrationFormData);
        setNextLoader(false);
      }
    } finally {
      setIsNext(false);
    }
  };

  const handleEdit = () => {
    setCurrentPage(0);
    setIsDisabled(false); // Enable the form fields
  };

  const handleBackClick = () => {
    if (currentPage === 0) {
      return;
    }
    setCurrentPage(currentPage - 1);  // Decrement the current page for pages 2, 3, 4, etc.
  };

  const handleRemoveFamilyMember = (index) => {
    if (index === 0) {
      setPatientRegistrationFormData((prevData) => ({
        ...prevData,
        familyMembers: [
          { name: "", relationship: "", dob: "", mobile_number: "" }, // Reset all fields for the first family member
        ],
      }));
      return;
    }
    const updatedFamilyMembers =
      PatientRegistrationFormData.familyMembers.filter((_, i) => i !== index);
    setPatientRegistrationFormData({
      ...PatientRegistrationFormData,
      familyMembers: updatedFamilyMembers,
    });
  };

  useEffect(() => {
    const date = PatientRegistrationFormData.dob;

    const calculateAge = date
      ? new Date().getFullYear() -
      new Date(date).getFullYear() -
      (new Date() <
        new Date(
          new Date(date).setFullYear(new Date().getFullYear())
        )
        ? 1
        : 0)
      : null;

    setAge(calculateAge);
  }, [PatientRegistrationFormData.dob]);

      const isFamilyMemberEmpty = (member) => {
        if (!member) return true;
        const { name, relationship, dob, mobile_number } = member;
        return [name, relationship, dob, mobile_number].every(
            (value) => !value || value.toString().trim() === ""
        );
    };

  const handleFamilyContentChange = (index, field, value) => {

    handleFamilyContentChanges({
      index,
      field,
      value,
      formData: PatientRegistrationFormData,
      setFormData: setPatientRegistrationFormData,
    });
  };



  return (
    <div className="min-h-screen flex justify-center bg-gray-50">
      <div className="min-h-screen flex flex-col w-full max-w-4xl bg-white">
        {nextLoader && <NextBtnLoader />}
        {isUploading && <Rocket />}
        {isLoading4 && (<Writing />)}
        <form className="bg-white">
          {currentPage > 0 && (
            <Back onClick={handleBackClick} />
          )}
          {/* Page 1 */}
          {currentPage === 0 && (
            <div className="space-y-6">
              <FormHeader pageTitle={subPageTitle} />
              <div className="px-4 py-2">

                <div className="my-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
                  {[
                    {
                      id: "firstName",
                      label: "First Name",
                      required: true,
                    },
                    {
                      id: "lastName",
                      label: "Last Name",
                      required: true,
                    }
                  ].map(({ id, label, required }) => (
                    <FormInput
                      key={id}
                      id={id}
                      label={label}
                      type="text"
                      disabled={isNext}
                      value={PatientRegistrationFormData[id]}
                      onChange={handleInputChange}
                      invalid={invalidFields.includes(label) && !PatientRegistrationFormData[id]}
                      required={required}
                    />
                  ))}
                </div>

                {/* Address */}
                <TextInput
                  id="address"
                  label="Address"
                  required
                  value={PatientRegistrationFormData.address}
                  onChange={handleInputChange}
                  disabled={isNext}
                  invalid={invalidFields.includes("Address") && !PatientRegistrationFormData.address}
                />

                <div className="my-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
                  {[
                    {
                      id: "city",
                      label: "City",
                      required: true,
                    },
                    {
                      id: "state",
                      label: "State",
                      required: true,
                    }
                  ].map(({ id, label, required }) => (
                    <FormInput
                      key={id}
                      id={id}
                      label={label}
                      type="text"
                      disabled={true}
                      value={PatientRegistrationFormData[id]}
                      onChange={handleInputChange}
                      invalid={invalidFields.includes(label) && !PatientRegistrationFormData[id]}
                      required={required}
                    />
                  ))}
                </div>
                {!isNext && (
                  <p className="text-sm text-muted-foreground mt-1">
                    City and State can be filled by using Zip
                  </p>
                )}

                <div className="my-4 grid grid-cols-1 sm:grid-cols-2 gap-4">

                  <FormInput
                    key="zip"
                    id="zip"
                    label="Zip"
                    type="text"
                    disabled={isNext}
                    value={PatientRegistrationFormData["zip"]}
                    onChange={handleInputChange}
                    invalid={invalidFields.includes("zip") && !PatientRegistrationFormData["zip"]}
                    required={true}
                    onZipSearch={handleZipSearch}
                  />

                  <FormInput
                    key="homephone"
                    id="homephone"
                    label="Home Phone"
                    type="number"
                    disabled={isNext}
                    value={PatientRegistrationFormData["homephone"]}
                    onChange={handleInputChange}
                    invalid={invalidFields.includes("homephone") && !PatientRegistrationFormData["homephone"]}
                    required={false}
                  />

                </div>

                <div className="my-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
                  {[
                    {
                      id: "cellphone",
                      label: "Cell Phone",
                      required: true,
                    },
                    {
                      id: "ssn",
                      label: "SSN",
                      required: false,
                    }
                  ].map(({ id, label, required }) => (
                    <FormInput
                      key={id}
                      id={id}
                      label={label}
                      type="number"
                      disabled={isNext}
                      value={PatientRegistrationFormData[id]}
                      onChange={handleInputChange}
                      invalid={invalidFields.includes(label) && !PatientRegistrationFormData[id]}
                      required={required}
                    />
                  ))}
                </div>

                <div className="mb-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <DobInput
                    value={PatientRegistrationFormData.dob}
                    onChange={(val) =>
                      setPatientRegistrationFormData((prev) => ({
                        ...prev,
                        dob: val || "",
                      }))
                    }
                    invalid={invalidFields.includes("DOB")}
                  />

                  {/* Preferred Language */}
                  <SelectInput
                    id="preferredLanguage"
                    label="Preferred Language"
                    options={languageOptions}
                    value={PatientRegistrationFormData.language}
                    onChange={(e) =>
                      setPatientRegistrationFormData((prev) => ({
                        ...prev,
                        language: e.target.value,
                      }))
                    }
                    disabled={isNext}
                    invalid={invalidFields.includes("preferredLanguage") && !PatientRegistrationFormData.language}
                    errorMessage="Please select a language."
                  />
                </div>

                {/* Gender & Text Consent */}
                <div className="mb-4 mt-6 grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <SelectInput
                    id="gender"
                    label="Gender *"
                    options={genderOptions}
                    value={PatientRegistrationFormData.gender}
                    onChange={(e) =>
                      setPatientRegistrationFormData((prev) => ({
                        ...prev,
                        gender: e.target.value,
                      }))
                    }
                    disabled={nextLoader}
                    invalid={invalidFields.includes("Gender") && !PatientRegistrationFormData.gender}
                    errorMessage="Please select a gender."
                  />
                  <DynamicCheckbox
                    label="Consent to Text"
                    fieldName="consentToText"
                    id="consentToText"
                    isChecked={PatientRegistrationFormData.consentToText}
                    onChange={handleInputChange}
                    isDisabled={isNext}
                    showError={invalidFields.includes("consentToText")}
                  />
                </div>

                <div className="mb-4 mt-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
                  {/* email*/}

                  <FormInput
                    key='email'
                    id='email'
                    label='Email'
                    type="text"
                    disabled={isNext}
                    value={PatientRegistrationFormData['email']}
                    onChange={handleInputChange}
                    invalid={invalidFields.includes('Email') && !PatientRegistrationFormData['email']}
                    required={true}
                  />

                </div>

                {/* Portal */}
                <MedicalPortalAccess
                  portalValue={PatientRegistrationFormData.portal}
                  onChange={handlePortalChange}
                  isDisabled={isNext}
                />

                {/* ethnicity Radio Buttons */}

                <div className="mb-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <SelectInput
                    id="ethnicity"
                    label="Ethnicity"
                    options={ethnicityOptions}
                    value={PatientRegistrationFormData.ethnicity}
                    onChange={(e) =>
                      setPatientRegistrationFormData((prev) => ({
                        ...prev,
                        ethnicity: e.target.value,
                      }))
                    }
                    disabled={isNext}
                    invalid={invalidFields.includes("ethnicity")}
                  />

                  <SelectInput
                    id="race"
                    label="Race"
                    options={raceOptions}
                    value={PatientRegistrationFormData.race}
                    onChange={(e) =>
                      setPatientRegistrationFormData((prev) => ({
                        ...prev,
                        race: e.target.value,
                      }))
                    }
                    disabled={isNext}
                    invalid={invalidFields.includes("race")}
                    errorMessage="Please select a race."
                  />
                </div>

                {/* Marital Status */}
                <div className="mb-4 mt-6 grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <SelectInput
                    id="maritalStatus"
                    label="Marital Status"
                    options={maritalOptions}
                    value={PatientRegistrationFormData.maritalStatus}
                    onChange={(e) =>
                      setPatientRegistrationFormData((prev) => ({
                        ...prev,
                        maritalStatus: e.target.value,
                      }))
                    }
                    disabled={isDisabled}
                    invalid={invalidFields.includes("maritalStatus")}
                    errorMessage="Please select a marital status."
                  />

                </div>
              </div>
            </div>
          )}
          {/* Page 2 */}
          {currentPage === 1 && (
            <div className="space-y-6">
              <div className="px-4 py-2">

                <div className="mb-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
                  {/* referred by */}

                  <FormInput
                    key="referredBy"
                    id="referredBy"
                    label="Referred By"
                    type="text"
                    disabled={isNext}
                    value={PatientRegistrationFormData["referredBy"]}
                    onChange={handleInputChange}
                    invalid={invalidFields.includes("Referred By")}
                    required={true}
                  />

                  {/* family doctor */}
                  <FormInput
                    key="familyDoctor"
                    id="familyDoctor"
                    label="Family Doctor"
                    type="text"
                    disabled={isNext}
                    value={PatientRegistrationFormData["familyDoctor"]}
                    onChange={handleInputChange}
                    invalid={invalidFields.includes("Family Doctor")}
                    required={true}
                  />

                </div>

                <div className="mb-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
                  {/* parentspouse*/}

                  <FormInput
                    key="parentspouse"
                    id="parentspouse"
                    label="Parent-Spouse"
                    type="text"
                    disabled={isNext}
                    value={PatientRegistrationFormData["parentspouse"]}
                    onChange={handleInputChange}
                    invalid={invalidFields.includes("parentspouse")}
                    required={false}
                  />

                  {/* state*/}
                  <FormInput
                    key="state"
                    id="state"
                    label="State"
                    type="text"
                    disabled={true}
                    value={PatientRegistrationFormData["state"]}
                    onChange={handleInputChange}
                    invalid={invalidFields.includes("State")}
                    required={false}
                  />

                </div>

                <div className="mb-4 grid grid-cols-1 gap-4">
                  <div className="flex items-center">
                    <Paragraph> {PatientRegistrationFormData.firstName}{" "}
                      {PatientRegistrationFormData.lastName} - {formattedDate} </Paragraph>
                  </div>
                </div>
                <div>
                  <label className="block text-base font-medium text-black w-full">
                    If Patient Is a Minor, Authorized By:
                  </label>

                  <div className="w-full rounded-lg bg-white mt-4">
                    {/* Signature Label */}


                    {/* Signature Canvas */}
                    <div className="relative">
                      {age < 18 ? (
                        <Signature
                          fieldName="responsiblePersonSignature"
                          label="Responsible Person Signature *"
                          formData={PatientRegistrationFormData}
                          isEditing={isEditing}
                          isDisabled={isNext}
                          signatures={signatures}
                          canvasRefs={canvasRefs}
                          invalidFields={invalidFields}
                          updateSignatureData={updateSignatureData}
                          clearSignature={clearSignature}
                          toggleEditMode={toggleEditMode}
                          isNext={isNext}
                        />
                      ) : (
                        <DisabledTextBox></DisabledTextBox>
                        // <input
                        //   type="text"
                        //   disabled
                        //   className="w-1/2 h-32 rounded-md shadow-sm border border-gray-300 bg-white-100 text-center text-black"
                        // />
                      )}
                    </div>
                  </div>
                </div>

                <div className="my-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
                  {[
                    {
                      id: "employee",
                      label: "Employee",
                      required: false,
                    },
                    {
                      id: "employeeEmail",
                      label: "Employee Email",
                      required: false,
                    }
                  ].map(({ id, label, required }) => (
                    <FormInput
                      key={id}
                      id={id}
                      label={label}
                      type="text"
                      disabled={isNext}
                      value={PatientRegistrationFormData[id]}
                      onChange={handleInputChange}
                      invalid={invalidFields.includes(label) && !PatientRegistrationFormData[id]}
                      required={required}
                    />
                  ))}
                </div>



                <div>
                  <div className="mb-4 mt-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
                    {/* work phone */}

                    <FormInput
                      key='workphone'
                      id='workphone'
                      label='Work Phone'
                      type="number"
                      disabled={isNext}
                      value={PatientRegistrationFormData['workphone']}
                      onChange={handleInputChange}
                      invalid={invalidFields.includes('Work Phone') && !PatientRegistrationFormData['workphone']}
                      required={false}
                    />


                    <FormInput
                      key='employeeExtn'
                      id='employeeExtn'
                      label='Extension'
                      type="text"
                      disabled={true}
                      value={PatientRegistrationFormData['employeeExtn']}
                      onChange={handleInputChange}
                      invalid={invalidFields.includes('Extension') && !PatientRegistrationFormData['employeeExtn']}
                      required={false}
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-base font-medium text-black w-full">
                    In Case Of Emergency Notify
                  </label>
                </div>

                <div className="my-4 grid grid-cols-1 sm:grid-cols-2 gap-4">

                  <FormInput
                    key="emergencyName"
                    id="emergencyName"
                    label="Emergency Name"
                    type="text"
                    disabled={isNext}
                    value={PatientRegistrationFormData["emergencyName"]}
                    onChange={handleInputChange}
                    invalid={invalidFields.includes("Emergency Name") && !PatientRegistrationFormData["emergencyName"]}
                    required={false}
                  />

                  <SelectInput
                    id="emergencyRelationship"
                    label="Emergency Relationship"
                    options={emergencyRelationshipOptions}
                    value={PatientRegistrationFormData.emergencyRelationship}
                    onChange={(e) =>
                      setPatientRegistrationFormData((prev) => ({
                        ...prev,
                        emergencyRelationship: e.target.value,
                      }))
                    }
                    disabled={isNext}
                    invalid={invalidFields.includes("Emergency Relationship")}
                    errorMessage="Please select a emergency relationship."
                  />
                </div>

                <div className="mb-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <FormInput
                    key="emergencyPhone"
                    id="emergencyPhone"
                    label='Emergency Phone'
                    type="number"
                    disabled={isNext}
                    value={PatientRegistrationFormData["emergencyPhone"]}
                    onChange={handleInputChange}
                    invalid={invalidFields.includes('Emergency Phone') && !PatientRegistrationFormData["emergencyPhone"]}
                    required={false}
                  />
                </div>
              </div>
            </div>
          )}
          {/* Page 3 */}
          {currentPage === 2 && (
            <div className="space-y-6">
              <FormHeader pageTitle={subPageTitle} />
              <div className="px-4 py-2">
                <AssignmentRelease />
                <div className="mb-6">
                  <Paragraph>
                    {PatientRegistrationFormData.firstName}{" "}
                    {PatientRegistrationFormData.lastName} - {formattedDate}
                  </Paragraph>
                </div>

                {age < 18 ? (
                  <div className="w-full rounded-lg bg-white p-4">
                    {/* Radio Button to Show Signature */}
                    {!showPatientSignature && (
                      <div className="mb-4">
                        <label className="inline-flex items-center">
                          <input
                            type="radio"
                            className="form-radio h-4 w-4 text-indigo-600 border-gray-300 checked:bg-sky-600"
                            onChange={() => setShowPatientSignature(true)}
                          />
                          <span className="ml-2 text-base font-medium text-black">I Agree</span>
                        </label>
                      </div>
                    )}


                    {showPatientSignature && (

                      <div className="w-full rounded-lg bg-white">

                        <div className="relative">
                          {age >= 18 ? (
                            <Signature
                              fieldName="patientSignature"
                              label="Signature *"
                              formData={PatientRegistrationFormData}
                              isEditing={isEditing}
                              isDisabled={isNext}
                              signatures={signatures}
                              canvasRefs={canvasRefs}
                              invalidFields={invalidFields}
                              updateSignatureData={updateSignatureData}
                              clearSignature={clearSignature}
                              toggleEditMode={toggleEditMode}
                              isNext={isNext}
                            />
                          ) : (
                            <DisabledTextBox></DisabledTextBox>
                            // <input
                            //   type="text"
                            //   disabled
                            //   className="w-1/2 h-32 rounded-md shadow-sm border border-gray-300 bg-white-100 text-center text-black"
                            // />
                          )}
                        </div>

                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-8">
                          <div className="w-full rounded-lg bg-white">
                            <label className="block text-base font-medium text-black mb-3">
                              Responsible Party Signature
                            </label>
                            {/* Signature Canvas */}
                            <div className="relative">
                              <div className="mb-4">
                                {age < 18 ? (
                                  <img
                                    src={signatures["responsiblePersonSignature"]}
                                    alt="Signature"
                                    loading="eager"
                                    style={{
                                      width: '300px',
                                      height: '100px',
                                      maxWidth: '100%',
                                      maxHeight: '100%',
                                      borderRadius: '0.375rem', // same as Tailwind's rounded-md
                                      border: '1px solid #D1D5DB', // Tailwind's border-gray-300
                                      objectFit: 'contain',
                                      display: 'block',
                                    }}
                                  />
                                ) : (
                                  <DisabledTextBox></DisabledTextBox>
                                  // <input
                                  //   type="text"
                                  //   disabled
                                  //   className="w-full h-32 rounded-md shadow-sm border border-gray-300 bg-white-100 text-center text-black"
                                  // />
                                )}
                              </div>
                            </div>
                          </div>

                          <FormInput
                            key="responsiblePersonRelationship"
                            id="responsiblePersonRelationship"
                            label='Relationship With Patient'
                            type="text"
                            disabled={isNext || age >= 18}
                            value={PatientRegistrationFormData["responsiblePersonRelationship"]}
                            onChange={handleInputChange}
                            invalid={invalidFields.includes('Relationship With Patient') && !PatientRegistrationFormData["responsiblePersonRelationship"]}
                            required={false}
                          />
                        </div>

                      </div>
                    )}


                  </div>
                ) : (
                  <div className="w-full rounded-lg bg-white">
                    {/* Signature Label */}
                    <div className="w-[50%] rounded-lg bg-white">

                      {/* Signature Canvas */}
                      <div className="relative">
                        {age >= 18 ? (
                          <Signature
                            fieldName="patientSignature"
                            label="Signature *"
                            formData={PatientRegistrationFormData}
                            isEditing={isEditing}
                            isDisabled={isNext}
                            signatures={signatures}
                            canvasRefs={canvasRefs}
                            invalidFields={invalidFields}
                            updateSignatureData={updateSignatureData}
                            clearSignature={clearSignature}
                            toggleEditMode={toggleEditMode}
                            isNext={isNext}
                          />
                        ) : (
                          <DisabledTextBox></DisabledTextBox>
                          // <input
                          //   type="text"
                          //   disabled
                          //   className="w-1/2 h-32 rounded-md shadow-sm border border-gray-300 bg-white-100 text-center text-black"
                          // />
                        )}
                      </div>
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-8">
                      <div className="w-full rounded-lg bg-white">
                        {/* Signature Label */}
                        <label className="block text-base font-medium text-black mb-3">
                          Responsible Party Signature
                        </label>
                        {/* Signature Canvas */}
                        <div className="relative">
                          <div className="mb-4">
                            {age < 18 ? (
                              <img
                                src={signatures["responsiblePersonSignature"]}
                                alt="Signature"
                                loading="eager"
                                style={{
                                  width: '300px',
                                  height: '100px',
                                  maxWidth: '100%',
                                  maxHeight: '100%',
                                  borderRadius: '0.375rem', // same as Tailwind's rounded-md
                                  border: '1px solid #D1D5DB', // Tailwind's border-gray-300
                                  objectFit: 'contain',
                                  display: 'block',
                                }}
                              />
                            ) : (
                              <DisabledTextBox className="w-full h-32 rounded-md shadow-sm border border-gray-300 bg-white-100 text-center text-black" />

                              // <input
                              //   type="text"
                              //   disabled
                              //   className="w-full h-32 rounded-md shadow-sm border border-gray-300 bg-white-100 text-center text-black"
                              // />
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="flex flex-col">
                        <label
                          htmlFor="responsiblePersonRelationship"
                          className="block text-base font-medium text-black mb-2"
                        >
                          Relationship With Patient
                        </label>
                        <input
                          id="responsiblePersonRelationship"
                          type="text"
                          value={
                            PatientRegistrationFormData.responsiblePersonRelationship
                          }
                          onChange={handleInputChange}
                          disabled={isNext || age >= 18}
                          className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-sky-500 focus:border-sky-500"
                        />
                      </div>
                    </div>

                  </div>
                )}


              </div>
            </div>
          )}
          {/* Page 4 */}
          {currentPage === 3 && (
            <div className="space-y-6">
              <FormHeader pageTitle={subPageTitle} />
              <div className="px-4 py-2">


                <div className="my-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
                  {[
                    {
                      id: "firstName",
                      label: "First Name",
                      required: false,
                    },
                    {
                      id: "lastName",
                      label: "Last Name",
                      required: false,
                    }
                  ].map(({ id, label, required }) => (
                    <FormInput
                      key={id}
                      id={id}
                      label={label}
                      type="text"
                      disabled={true}
                      value={PatientRegistrationFormData[id]}
                      onChange={handleInputChange}
                      invalid={invalidFields.includes(label) && !PatientRegistrationFormData[id]}
                      required={required}
                    />
                  ))}
                </div>

                <div className="my-4 grid grid-cols-1 sm:grid-cols-2 gap-4">

                  <FormInput
                    key='dob'
                    id='dob'
                    label='DOB'
                    type="text"
                    disabled={true}
                    value={PatientRegistrationFormData['dob']}
                    onChange={handleInputChange}
                    invalid={invalidFields.includes('DOB') && !PatientRegistrationFormData['dob']}
                    required={false}
                  />

                  <FormInput
                    key='date'
                    id='date'
                    label='Date'
                    type="text"
                    disabled={true}
                    value={formattedDate}
                    onChange={handleInputChange}
                    invalid={false}
                    required={false}
                  />

                </div>


                {/* Medication */}
                <TextInput
                  id="medication"
                  label="List of Medication"
                  value={PatientRegistrationFormData.medication}
                  onChange={handleInputChange}
                  disabled={isNext}
                  invalid={invalidFields.includes("medication") && !PatientRegistrationFormData.medication}
                />
                {/* Allergies */}
                <TextInput
                  id="allergies"
                  label="Allergies To Medications"
                  value={PatientRegistrationFormData.allergies}
                  onChange={handleInputChange}
                  disabled={isNext}
                  invalid={invalidFields.includes("allergies") && !PatientRegistrationFormData.allergies}
                />

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                  {/* Left Column - Symptoms */}
                  <div>
                    <div className="mb-4">
                      <label className="block text-base font-medium text-black col-span-1">
                        Do you presently have any of the following symptoms?
                      </label>
                      <div className="flex justify-end items-center gap-4">
                        <span className="text-base font-medium text-black">
                          Yes
                        </span>
                        <span className="text-base font-medium text-black">
                          No
                        </span>
                      </div>
                    </div>

                    {Object.keys(PatientRegistrationFormData.symptoms).map(
                      (symptom) => (
                        <div
                          key={symptom}
                          className="flex items-center justify-between mb-3"
                        >
                          <label className="text-base font-medium text-black">
                            {symptom}
                          </label>
                          <div className="flex items-center gap-4">
                            {/* Yes Checkbox */}
                            <input
                              type="checkbox"
                              id={`${symptom}-yes`}
                              checked={
                                PatientRegistrationFormData.symptoms[symptom] ===
                                true
                              }
                              onChange={() =>
                                handleCheckboxChange("symptoms", symptom, true)
                              }
                              disabled={isDisabled}
                              className="form-checkbox h-5 w-5 text-sky-600 border-gray-300 rounded"
                            />
                            {/* No Checkbox */}
                            <input
                              type="checkbox"
                              id={`${symptom}-no`}
                              checked={
                                PatientRegistrationFormData.symptoms[symptom] ===
                                false
                              }
                              onChange={() =>
                                handleCheckboxChange("symptoms", symptom, false)
                              }
                              disabled={isNext}
                              className="form-checkbox h-5 w-5 text-sky-600 border-gray-300 rounded"
                            />
                          </div>
                        </div>
                      )
                    )}
                  </div>

                  {/* Right Column - Medical History */}
                  <div>
                    <div className="mb-4">
                      <label className="block text-base font-medium text-black col-span-1">
                        Indicate your past or present medical history
                      </label>
                      <div className="flex justify-end items-center gap-4">
                        <span className="text-base font-medium text-black">
                          Yes
                        </span>
                        <span className="text-base font-medium text-black">
                          No
                        </span>
                      </div>
                    </div>

                    {Object.keys(PatientRegistrationFormData.medicalHistory).map(
                      (history) => (
                        <div
                          key={history}
                          className="flex items-center justify-between mb-3"
                        >
                          <label className="text-base font-medium text-black">
                            {history}
                          </label>
                          <div className="flex items-center gap-4">
                            {/* Yes Checkbox */}
                            <input
                              type="checkbox"
                              id={`${history}-yes`}
                              checked={
                                PatientRegistrationFormData.medicalHistory[
                                history
                                ] === true
                              }
                              onChange={() =>
                                handleCheckboxChange(
                                  "medicalHistory",
                                  history,
                                  true
                                )
                              }
                              disabled={isNext}
                              className="form-checkbox h-5 w-5 text-sky-600 border-gray-300 rounded"
                            />
                            {/* No Checkbox */}
                            <input
                              type="checkbox"
                              id={`${history}-no`}
                              checked={
                                PatientRegistrationFormData.medicalHistory[
                                history
                                ] === false
                              }
                              onChange={() =>
                                handleCheckboxChange(
                                  "medicalHistory",
                                  history,
                                  false
                                )
                              }
                              disabled={isNext}
                              className="form-checkbox h-5 w-5 text-sky-600 border-gray-300 rounded"
                            />
                          </div>
                        </div>
                      )
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
          {/* Page 5 */}
          {currentPage === 4 && (
            <div className="space-y-6">
              <div className="px-4 py-2">
                <div className="my-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
                  {[
                    {
                      id: "firstName",
                      label: "First Name",
                      required: false,
                    },
                    {
                      id: "lastName",
                      label: "Last Name",
                      required: false,
                    }
                  ].map(({ id, label, required }) => (
                    <FormInput
                      key={id}
                      id={id}
                      label={label}
                      type="text"
                      disabled={true}
                      value={PatientRegistrationFormData[id]}
                      onChange={handleInputChange}
                      invalid={invalidFields.includes(label) && !PatientRegistrationFormData[id]}
                      required={required}
                    />
                  ))}
                </div>

                <div className="my-4 grid grid-cols-1 sm:grid-cols-2 gap-4">

                  <FormInput
                    key='dob'
                    id='dob'
                    label='DOB'
                    type="text"
                    disabled={true}
                    value={PatientRegistrationFormData['dob']}
                    onChange={handleInputChange}
                    invalid={invalidFields.includes('DOB') && !PatientRegistrationFormData['dob']}
                    required={false}
                  />

                  <FormInput
                    key='date'
                    id='date'
                    label='Date'
                    type="text"
                    disabled={true}
                    value={formattedDate}
                    onChange={handleInputChange}
                    invalid={false}
                    required={false}
                  />

                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                  <div>
                    <div className="mb-4">
                      <label className="block text-base font-medium text-black col-span-1">
                        Any diseases in the family? If "YES," please indicate
                        relationship to you.
                      </label>
                      <div className="flex justify-end items-center gap-4">
                        <span className="text-base font-medium text-black">
                          Yes
                        </span>
                        <span className="text-base font-medium text-black">
                          No
                        </span>
                      </div>
                    </div>


                    {Object.keys(PatientRegistrationFormData.familyDiseases).map((disease) => (
                      <div
                        key={disease}
                        className="flex items-center justify-between mb-3"
                      >
                        <label className="text-base font-medium text-black w-1/4">
                          {disease}
                        </label>

                        {/* Relationship input */}
                        <input
                          type="text"
                          value={
                            PatientRegistrationFormData.familyDiseases[disease]?.relationship || ""
                          }
                          onChange={(e) =>
                            handleRelationshipChange("familyDiseases", disease, e.target.value)
                          }
                          disabled={isNext}
                          className={`${isNext ? "!text-black !opacity-100" : ""} border-b border-gray-400 font-medium border-t-0 border-l-0 border-r-0 focus:outline-none focus:border-sky-600 px-2 py-1 w-1/3 bg-slate-50`}
                        />

                        {/* Yes/No checkboxes */}
                        <div className="flex items-center gap-4">
                          {/* Yes Checkbox */}
                          <input
                            type="checkbox"
                            id={`${disease}-yes`}
                            checked={
                              PatientRegistrationFormData.familyDiseases[disease]?.hasDisease ===
                              "Yes"
                            }
                            onChange={() =>
                              handleCheckboxChangeForFamily("familyDiseases", disease, "Yes")
                            }
                            disabled={isNext}
                            className="form-checkbox h-5 w-5 text-sky-600 border-gray-300 rounded"
                          />
                          {/* No Checkbox */}
                          <input
                            type="checkbox"
                            id={`${disease}-no`}
                            checked={
                              PatientRegistrationFormData.familyDiseases[disease]?.hasDisease ===
                              "No"
                            }
                            onChange={() =>
                              handleCheckboxChangeForFamily("familyDiseases", disease, "No")
                            }
                            disabled={isNext}
                            className="form-checkbox h-5 w-5 text-sky-600 border-gray-300 rounded"
                          />
                        </div>
                      </div>
                    ))}

                  </div>
                </div>
                {/* List Of Surgeries */}

                <TextInput
                  id="surgeries"
                  label="List of surgeries You Have Had In The Past"
                  value={PatientRegistrationFormData.surgeries}
                  onChange={handleInputChange}
                  disabled={isNext}
                  invalid={invalidFields.includes("surgeries") && !PatientRegistrationFormData.surgeries}
                />

                <div>
                  {/* Do you smoke? question */}
                  <div className="flex items-center gap-4 mb-4">
                    <label className="text-base font-medium text-black">
                      Do you smoke?
                    </label>

                    {/* Yes/No Checkboxes */}
                    <div className="flex items-center gap-4">
                      <input
                        type="checkbox"
                        id="smoke-yes"
                        checked={PatientRegistrationFormData.smoker === true}
                        onChange={() => {
                          handleCheckChange("smoker", true);
                          setPatientRegistrationFormData((prev) => ({
                            ...prev,
                            smokedInPast: "", // Clear packs per day when smoker is checked
                          }));
                        }}
                        disabled={isNext}
                        className="form-radio font-medium h-5 w-5 border-gray-300 checked:bg-sky-600"
                      />
                      <label
                        htmlFor="smoke-yes"
                        className="text-base font-medium text-black"
                      >
                        Yes
                      </label>

                      <input
                        type="checkbox"
                        id="smoke-no"
                        checked={PatientRegistrationFormData.smoker === false}
                        onChange={() => {
                          setPatientRegistrationFormData((prev) => ({
                            ...prev,
                            packsPerDay: "", // Assign the value directly
                          }));
                          handleCheckChange("smoker", false);
                        }}
                        disabled={isNext}
                        className="form-radio font-medium h-5 w-5 border-gray-300 checked:bg-sky-600"
                      />
                      <label htmlFor="smoke-no" className="text-base font-medium text-black">
                        No
                      </label>

                      <label
                        htmlFor="packs-per-day"
                        className="text-base font-medium text-black"
                      >
                        Packs per day:
                      </label>
                      <input
                        id="packs-per-day"
                        type="number"
                        min="0"
                        value={PatientRegistrationFormData.packsPerDay}
                        onChange={handlePacksChange}
                        disabled={
                          isNext ||
                          PatientRegistrationFormData.smoker === false
                        }
                        className="h-8 w-16 px-3 py-2 bg-slate-50 font-medium border-0 border-b-2 border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                      />
                    </div>
                  </div>
                </div>

                <div className="flex items-center gap-4 mb-4">
                  <label className="text-base font-medium text-black">
                    Have you smoked in the past?
                  </label>

                  <div className="flex items-center gap-4">
                    <input
                      type="radio"
                      id="smoked-past-yes"
                      name="smoked-past"
                      value="yes"
                      checked={PatientRegistrationFormData.smokedInPast === true}
                      onChange={() => handleCheckChange("smokedInPast", true)}
                      disabled={
                        isNext || PatientRegistrationFormData.smoker === true
                      }
                      className="form-radio h-5 w-5 bg-slate-50 font-medium border-0 border-b-2 border-gray-300  checked:bg-sky-600"
                    />
                    <label
                      htmlFor="smoked-past-yes"
                      className="text-base font-medium text-black"
                    >
                      Yes
                    </label>

                    <input
                      type="radio"
                      id="smoked-past-no"
                      name="smoked-past"
                      value="no"
                      checked={PatientRegistrationFormData.smokedInPast === false}
                      onChange={() => handleCheckChange("smokedInPast", false)}
                      disabled={
                        isNext || PatientRegistrationFormData.smoker === true
                      }
                      className="form-radio h-5 w-5 font-medium border-gray-300 checked:bg-sky-600"
                    />
                    <label
                      htmlFor="smoked-past-no"
                      className="text-base font-medium text-black"
                    >
                      No
                    </label>
                  </div>
                </div>

                <div>
                  {/* Do you drink alcohol? question */}
                  <div className="flex items-center gap-4 mb-4">
                    <label className="text-base font-medium text-black">
                      Do you drink alcohol?
                    </label>

                    {/* Yes/No Radio Buttons */}
                    <div className="flex items-center gap-4">
                      <input
                        type="radio"
                        id="alcohol-yes"
                        name="alcohol"
                        value="yes"
                        checked={
                          PatientRegistrationFormData.drinksAlcohol === true
                        }
                        onChange={() => handleCheckChange("drinksAlcohol", true)}
                        disabled={isNext}
                        className="form-radio h-5 w-5 font-medium border-gray-300 checked:bg-sky-600"
                      />
                      <label
                        htmlFor="alcohol-yes"
                        className="text-base font-medium text-black"
                      >
                        Yes
                      </label>

                      <input
                        type="radio"
                        id="alcohol-no"
                        name="alcohol"
                        value="no"
                        checked={
                          PatientRegistrationFormData.drinksAlcohol === false
                        }
                        onChange={() => {
                          setPatientRegistrationFormData((prev) => ({
                            ...prev,
                            glassesPerDay: "", // Assign the value directly
                          }));
                          handleCheckChange("drinksAlcohol", false);
                        }}
                        disabled={isDisabled}
                        className="form-radio h-5 w-5 font-medium border-gray-300 checked:bg-sky-600"
                      />
                      <label
                        htmlFor="alcohol-no"
                        className="text-base text-black font-medium"
                      >
                        No
                      </label>

                      <label
                        htmlFor="glasses-per-day"
                        className="text-base font-medium text-black"
                      >
                        Number of glasses per day:
                      </label>
                      <input
                        id="glasses-per-day"
                        type="number"
                        min="0"
                        value={PatientRegistrationFormData.glassesPerDay}
                        onChange={handleGlassesChange}
                        disabled={
                          isNext ||
                          PatientRegistrationFormData.drinksAlcohol === false
                        }
                        className="h-8 w-16 px-3 py-2 font-medium border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                      />
                    </div>
                  </div>
                </div>

                {/* Are you married? question */}
                <div className="flex items-center gap-4 mb-4">
                  <label className="text-base font-medium text-black">
                    Are you married?
                  </label>

                  {/* Yes/No Radio Buttons */}
                  <div className="flex items-center gap-4">
                    <input
                      type="radio"
                      id="married-yes"
                      name="married"
                      value="yes"
                      checked={PatientRegistrationFormData.isMarried === true}
                      onChange={() => handleCheckChange("isMarried", true)}
                      disabled={isNext}
                      className="form-radio h-5 w-5 border-gray-300 font-medium checked:bg-sky-600"
                    />
                    <label
                      htmlFor="married-yes"
                      className="text-base text-black font-medium"
                    >
                      Yes
                    </label>

                    <input
                      type="radio"
                      id="married-no"
                      name="married"
                      value="no"
                      checked={PatientRegistrationFormData.isMarried === false}
                      onChange={() => handleCheckChange("isMarried", false)}
                      disabled={isNext}
                      className="form-radio h-5 w-5 border-gray-300 checked:bg-sky-600"
                    />
                    <label htmlFor="married-no" className="text-base font-medium text-black">
                      No
                    </label>
                  </div>
                </div>

                {/* Do you drive? question */}
                <div className="flex items-center gap-4 mb-4">
                  <label className="text-base font-medium text-black">
                    Do you drive?
                  </label>

                  {/* Yes/No Radio Buttons */}
                  <div className="flex items-center gap-4">
                    <input
                      type="radio"
                      id="drive-yes"
                      name="drive"
                      value="yes"
                      checked={PatientRegistrationFormData.doYouDrive === true}
                      onChange={() => handleCheckChange("doYouDrive", true)}
                      disabled={isNext}
                      className="form-radio h-5 w-5 border-gray-300 checked:bg-sky-600"
                    />
                    <label htmlFor="drive-yes" className="text-base font-medium text-black">
                      Yes
                    </label>

                    <input
                      type="radio"
                      id="drive-no"
                      name="drive"
                      value="no"
                      checked={PatientRegistrationFormData.doYouDrive === false}
                      onChange={() => handleCheckChange("doYouDrive", false)}
                      disabled={isNext}
                      className="form-radio h-5 w-5 border-gray-300 checked:bg-sky-600"
                    />
                    <label htmlFor="drive-no" className="text-base font-medium text-black">
                      No
                    </label>
                  </div>
                </div>

                {/* Other Important Information */}
                <TextInput
                  id="other_important_information"
                  label="Other Important Information"
                  value={PatientRegistrationFormData.other_important_information}
                  onChange={handleInputChange}
                  disabled={isDisabled}
                  invalid={invalidFields.includes("other_important_information") && !PatientRegistrationFormData.other_important_information}
                />

                {!showPatientSignaturePage4 ? (
                  <div className="w-[50%] bg-white">
                    {!showPatientSignaturePage4 && (
                      <div className="mb-4">
                        <label className="inline-flex items-center">
                          <input
                            type="radio"
                            className="form-radio h-4 w-4 text-indigo-600 border-gray-300 checked:bg-sky-600"
                            checked={showPatientSignaturePage4}
                            onChange={() =>
                              setShowPatientSignaturePage4(!showPatientSignaturePage4)
                            }
                          />
                          <span className="ml-2 text-base font-medium text-black">
                            I Agree*
                          </span>
                        </label>
                      </div>)}
                    <div className="w-full rounded-lg bg-white">

                    </div>
                  </div>
                ) : (
                  <div className="w-full bg-white mb-3">
                    {/* Signatures Section */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      {/* Patient Signature */}
                      {age >= 18 && (
                        <div className="w-full rounded-lg bg-white">
                          <label className="block text-base font-medium text-black mb-3">
                            Patient's Signature
                          </label>

                          {/* Show Radio Button Only If No Existing Signature */}
                          {!signatures["patientSignature"] ? (
                            !showPatientSignature && (
                              <div className="mb-4">
                                <label className="inline-flex items-center">
                                  <input
                                    type="radio"
                                    className="form-radio h-4 w-4 text-indigo-600 border-gray-300 checked:bg-sky-600"
                                    checked={showPatientSignature}
                                    onChange={() => setShowPatientSignature(true)}
                                  />
                                  <span className="ml-2 text-base font-medium text-black">I Agree*</span>
                                </label>
                              </div>
                            )
                          ) : null}


                          {/* Show Signature Only If Radio is Selected or Signature Exists */}
                          {showPatientSignature ||
                            signatures["patientSignature"] ? (
                            <img
                              src={signatures["patientSignature"]}
                              alt="Signature"
                              loading="eager"
                              style={{
                                width: '300px',
                                height: '100px',
                                maxWidth: '100%',
                                maxHeight: '100%',
                                borderRadius: '0.375rem', // same as Tailwind's rounded-md
                                border: '1px solid #D1D5DB', // Tailwind's border-gray-300
                                objectFit: 'contain',
                                display: 'block',
                              }}
                            />
                          ) : null}
                        </div>
                      )}

                      {/* Responsible Party Signature (for age < 18) */}
                      {age < 18 && (
                        <div className="w-full rounded-lg bg-white p-4">
                          <label className="block text-base font-medium text-black mb-3">
                            Responsible Party Signature
                          </label>
                          <img
                            src={signatures["responsiblePersonSignature"]}
                            alt="Signature"
                            loading="eager"
                            style={{
                              width: '300px',
                              height: '100px',
                              maxWidth: '100%',
                              maxHeight: '100%',
                              borderRadius: '0.375rem', // same as Tailwind's rounded-md
                              border: '1px solid #D1D5DB', // Tailwind's border-gray-300
                              objectFit: 'contain',
                              display: 'block',
                            }}
                          />
                        </div>
                      )}

                    </div>
                  </div>
                )}

                <div className="mb-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
                  {/* date*/}

                  <FormInput
                    key='date'
                    id='date'
                    label='Date'
                    type="text"
                    disabled={true}
                    value={formattedDate}
                    onChange={handleInputChange}
                    invalid={false}
                    required={false}
                  />
                </div>
              </div>
            </div>
          )}
          {/* Page 6 */}
          {currentPage === 5 && (
            <div className="space-y-6">
              <FormHeader pageTitle={subPageTitle} />
              <div className="px-4 py-2">
                <PrivacyConsent />
                {/* Signature Section */}
                <div className="mb-8">
                  <p className="text-base font-medium text-black mb-3">
                    {PatientRegistrationFormData.firstName}{" "}
                    {PatientRegistrationFormData.lastName} - {formattedDate}
                  </p>
                </div>
                {showPatientSignaturePage5 ? (
                  age < 18 ? (
                    <div className="w-1/2 rounded-lg bg-white">
                      {/* Signature Label */}
                      <label className="block text-base font-medium text-black mb-3">
                        Responsible Party Signature
                      </label>
                      <img
                        src={signatures["responsiblePersonSignature"]}
                        alt="Signature"
                        loading="eager"
                        style={{
                          width: '300px',
                          height: '100px',
                          maxWidth: '100%',
                          maxHeight: '100%',
                          borderRadius: '0.375rem', // same as Tailwind's rounded-md
                          border: '1px solid #D1D5DB', // Tailwind's border-gray-300
                          objectFit: 'contain',
                          display: 'block',
                        }}
                      />
                    </div>
                  ) : (
                    <div className="w-1/2 rounded-lg bg-white">
                      {/* Signature Label */}
                      <label className="block text-base font-medium text-black mb-3">
                        Patient Signature
                      </label>
                      <img
                        src={signatures["patientSignature"]}
                        alt="Signature"
                        loading="eager"
                        style={{
                          width: '300px',
                          height: '100px',
                          maxWidth: '100%',
                          maxHeight: '100%',
                          borderRadius: '0.375rem', // same as Tailwind's rounded-md
                          border: '1px solid #D1D5DB', // Tailwind's border-gray-300
                          objectFit: 'contain',
                          display: 'block',
                        }}
                      />
                    </div>
                  )
                ) : (
                  !showPatientSignaturePage5 && (
                    <div className="mb-4">
                      <label className="inline-flex items-center">
                        <input
                          type="radio"
                          className="form-radio h-4 w-4 text-indigo-600 border-gray-300 checked:bg-sky-600"
                          checked={showPatientSignaturePage5}
                          onChange={() =>
                            setShowPatientSignaturePage5(!showPatientSignaturePage5)
                          }
                        />
                        <span className="ml-2 text-base font-medium text-black">
                          I Agree *
                        </span>
                      </label>
                    </div>
                  )
                )}


                {/* Permissions Section */}
                <div className="space-y-6">
                  <div>
                    <div>
                      {/* Emergency Contact Information Heading */}
                      <p className="text-lg font-semibold text-center text-black">
                        Family Member Consent
                      </p>
                    </div>

                    <div className="text-black">
                      <Paragraph>
                        With your permission, Retina Specialty Institute may release your protected health information to a family member, or another person involved in your care or payment for your care.
                      </Paragraph>
                      <Paragraph>
                        Please identify the person or persons who are involved in your care or the payment of your care that you can authorize to receive your protected health information. This may include your spouse, parent, siblings, children, close friend, or guardian. Please list below:
                      </Paragraph>
                    </div>

                    <div className="hidden lg:grid grid-cols-[1fr_1fr_1fr_1fr_40px] gap-4 mb-2 font-medium text-sm text-gray-700 px-2">
                      <div>Name</div>
                      <div>Relationship</div>
                      <div>Date of Birth</div>
                      <div>Phone</div>
                      <div></div>
                    </div>

                    {/* Family Members */}
                    <div className="space-y-4">
                      {PatientRegistrationFormData.familyMembers.map((member, index) => (
                        <div
                          key={index}
                          className="bg-gray-50 p-4 rounded-lg border border-gray-200"
                        >
                          {/* Mobile/Tablet: Stacked Layout */}
                          <div className="lg:hidden space-y-4">
                            <div>
                              <label className="text-xs font-medium text-gray-600 mb-1 block">Name</label>
                              <input
                                value={member.name}
                                onChange={(e) => handleFamilyContentChange(index, 'name', e.target.value)}
                                className="w-full px-3 py-2 bg-white border border-gray-300 rounded-md text-sm"
                                placeholder="Full Name"
                              />
                            </div>
                            <div>
                              <label className="text-xs font-medium text-gray-600 mb-1 block">Relationship</label>
                              <input
                                value={member.relationship}
                                onChange={(e) => handleFamilyContentChange(index, 'relationship', e.target.value)}
                                className="w-full px-3 py-2 bg-white border border-gray-300 rounded-md text-sm"
                                placeholder="Relationship"
                              />
                            </div>
                            <div>
                              <label className="text-xs font-medium text-gray-600 mb-1 block">Date of Birth</label>
                              <input
                                type="text"
                                value={member.dob}
                                onChange={(e) => handleFamilyContentChange(index, 'dob', e.target.value)}
                                placeholder="MM/DD/YYYY"
                                className="w-full px-3 py-2 bg-white border border-gray-300 rounded-md text-sm"
                              />
                            </div>
                            <div>
                              <label className="text-xs font-medium text-gray-600 mb-1 block">Phone</label>
                              <input
                                type="tel"
                                value={member.mobile_number}
                                onChange={(e) => handleFamilyContentChange(index, 'mobile_number', e.target.value)}
                                className="w-full px-3 py-2 bg-white border border-gray-300 rounded-md text-sm"
                                placeholder="Phone Number"
                              />
                            </div>
                            {!isFamilyMemberEmpty(member) && (
                              <button
                                type="button"
                                onClick={() => handleRemoveFamilyMember(index)}
                                className="flex items-center gap-2 text-red-600 hover:text-red-700 text-sm font-medium"
                              >
                                <FaTrash className="w-5 h-5" />
                                Remove
                              </button>
                            )}
                          </div>

                          {/* Desktop: Grid Layout */}
                          <div className="hidden lg:grid grid-cols-[1fr_1fr_1fr_1fr_auto] gap-4 items-center">
                            <input
                              value={member.name}
                              onChange={(e) => handleFamilyContentChange(index, 'name', e.target.value)}
                              className="px-3 py-2 bg-white border border-gray-300 rounded-md text-sm"
                              placeholder="Full Name"
                            />
                            <input
                              value={member.relationship}
                              onChange={(e) => handleFamilyContentChange(index, 'relationship', e.target.value)}
                              className="px-3 py-2 bg-white border border-gray-300 rounded-md text-sm"
                              placeholder="Relationship"
                            />
                            <input
                              type="text"
                              value={member.dob}
                              onChange={(e) => handleFamilyContentChange(index, 'dob', e.target.value)}
                              placeholder="MM/DD/YYYY"
                              className="px-3 py-2 bg-white border border-gray-300 rounded-md text-sm"
                            />
                            <input
                              type="tel"
                              value={member.mobile_number}
                              onChange={(e) => handleFamilyContentChange(index, 'mobile_number', e.target.value)}
                              className="px-3 py-2 bg-white border border-gray-300 rounded-md text-sm"
                              placeholder="Phone"
                            />
                            {!isFamilyMemberEmpty(member) && (
                              <button
                                type="button"
                                onClick={() => handleRemoveFamilyMember(index)}
                                className="text-red-600 hover:text-red-700 p-1 justify-self-center"
                              >
                                <FaTrash className="w-5 h-5" />
                              </button>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>

                  </div>
                </div>
              </div>
            </div>
          )}
          {/* Page 7 */}
          {currentPage === 6 && (
            <div className="space-y-6">
              <FormHeader pageTitle={subPageTitle} />
              <div className="px-4 py-2 text-black">
                <ImageConsent />
                <div className="my-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
                  {[
                    {
                      id: "firstName",
                      label: "First Name",
                      required: false,
                    },
                    {
                      id: "lastName",
                      label: "Last Name",
                      required: false,
                    }
                  ].map(({ id, label, required }) => (
                    <FormInput
                      key={id}
                      id={id}
                      label={label}
                      type="text"
                      disabled={true}
                      value={PatientRegistrationFormData[id]}
                      onChange={handleInputChange}
                      invalid={invalidFields.includes(label) && !PatientRegistrationFormData[id]}
                      required={required}
                    />
                  ))}
                </div>

                <div className="my-4 grid grid-cols-1 sm:grid-cols-2 gap-4">

                  <FormInput
                    key='dob'
                    id='dob'
                    label='DOB'
                    type="text"
                    disabled={true}
                    value={PatientRegistrationFormData['dob']}
                    onChange={handleInputChange}
                    invalid={invalidFields.includes('DOB') && !PatientRegistrationFormData['dob']}
                    required={false}
                  />

                  <FormInput
                    key='date'
                    id='date'
                    label='Date'
                    type="text"
                    disabled={true}
                    value={formattedDate}
                    onChange={handleInputChange}
                    invalid={false}
                    required={false}
                  />

                </div>

                {isNext ? null : (
                  <div className="flex items-center gap-4 mb-4 pt-4">
                    <label className="text-base font-medium text-black">
                      Image Consent *
                    </label>
                    <div className="flex items-center gap-4">
                      <input
                        type="radio"
                        id="imageConsent-yes"
                        name="imageConsent"
                        value={true}
                        checked={
                          PatientRegistrationFormData.imageConsent === "true"
                        }
                        onChange={() => handleImageConsentChange("true")}
                        disabled={isDisabled}
                        className="form-radio h-5 w-5 border-gray-300 checked:bg-sky-600"
                      />
                      <label
                        htmlFor="imageConsent-yes"
                        className="text-base font-medium text-black"
                      >
                        Agree
                      </label>

                      <input
                        type="radio"
                        id="imageConsent-no"
                        name="imageConsent"
                        value={false}
                        checked={
                          PatientRegistrationFormData.imageConsent === "false"
                        }
                        onChange={() => handleImageConsentChange("false")}
                        disabled={isDisabled}
                        className="form-radio h-5 w-5 border-gray-300 checked:bg-sky-600"
                      />
                      <label
                        htmlFor="imageConsent-no"
                        className="text-base font-medium text-black"
                      >
                        Disagree
                      </label>
                    </div>
                  </div>
                )}

                {PatientRegistrationFormData.imageConsent === "true" ? (
                  <div className="w-full bg-white">
                    {/* Signatures Section */}
                    {/* Patient Signature */}
                    <div className="w-full rounded-lg bg-white">
                      {/* Signature Canvas */}
                      <div className="relative">
                        {age < 18 ? (
                          <div className="w-1/2 rounded-lg bg-white">
                            {/* Signature Label */}
                            <label className="block text-base font-medium text-black mb-3">
                              Responsible Party Signature
                            </label>
                            <img
                              src={signatures["responsiblePersonSignature"]}
                              alt="Responsible Party Signature"
                              loading="eager"
                              style={{
                                width: '300px',
                                height: '100px',
                                maxWidth: '100%',
                                maxHeight: '100%',
                                borderRadius: '0.375rem', // same as Tailwind's rounded-md
                                border: '1px solid #D1D5DB', // Tailwind's border-gray-300
                                objectFit: 'contain',
                                display: 'block',
                              }}
                            />
                          </div>
                        ) : (
                          <div className="w-1/2 rounded-lg bg-white">
                            {/* Signature Label */}
                            <label className="block text-base font-medium text-black mb-3">
                              Patient Signature
                            </label>
                            <img
                              src={signatures["patientSignature"]}
                              alt="Patient Signature"
                              loading="eager"
                              style={{
                                width: '300px',
                                height: '100px',
                                maxWidth: '100%',
                                maxHeight: '100%',
                                borderRadius: '0.375rem', // same as Tailwind's rounded-md
                                border: '1px solid #D1D5DB', // Tailwind's border-gray-300
                                objectFit: 'contain',
                                display: 'block',
                              }}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                ) : null}
                <div></div>
              </div>
            </div>
          )}
          {/* Page 8 */}
          {currentPage === 7 && (
            <div className="space-y-6">
              <FormHeader pageTitle={subPageTitle} />
              <div className="px-4 py-2  text-black">
                <FinancialPolicy />
                <div className="mt-4 w-full bg-white">
                  {/* Patient Signature */}
                  <div className="w-full rounded-lg bg-white">
                    {/* Signature Canvas */}
                    {showPatientSignaturePage6 ? (
                      <div className="relative">
                        {age < 18 ? (
                          <div className="w-1/2 rounded-lg bg-white">
                            {/* Signature Label */}
                            <label className="block text-base font-medium text-black mb-3">
                              Responsible Party Signature
                            </label>
                            <img
                              src={signatures["responsiblePersonSignature"]}
                              alt="Responsible Party Signature"
                              loading="eager"
                              style={{
                                width: '300px',
                                height: '100px',
                                maxWidth: '100%',
                                maxHeight: '100%',
                                borderRadius: '0.375rem', // same as Tailwind's rounded-md
                                border: '1px solid #D1D5DB', // Tailwind's border-gray-300
                                objectFit: 'contain',
                                display: 'block',
                              }}
                            />
                          </div>
                        ) : (
                          <div className="w-1/2 rounded-lg bg-white">
                            {/* Signature Label */}
                            <label className="block text-base font-medium text-black mb-3">
                              Patient Signature
                            </label>
                            <img
                              src={signatures["patientSignature"]}
                              alt="Patient Signature"
                              loading="eager"
                              style={{
                                width: '300px',
                                height: '100px',
                                maxWidth: '100%',
                                maxHeight: '100%',
                                borderRadius: '0.375rem', // same as Tailwind's rounded-md
                                border: '1px solid #D1D5DB', // Tailwind's border-gray-300
                                objectFit: 'contain',
                                display: 'block',
                              }}
                            />
                          </div>
                        )}
                      </div>
                    ) : (
                      !showPatientSignaturePage6 && (
                        <div className="mb-4">
                          <label className="inline-flex items-center">
                            <input
                              type="radio"
                              className="form-radio h-4 w-4 text-indigo-600 border-gray-300 checked:bg-sky-600"
                              checked={showPatientSignaturePage6}
                              onChange={() =>
                                setShowPatientSignaturePage6(!showPatientSignaturePage6)
                              }
                            />
                            <span className="ml-2 text-base font-medium text-black">
                              I Agree*
                            </span>
                          </label>
                        </div>)
                    )}

                  </div>
                </div>


                <div className="my-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
                  {[
                    {
                      id: "firstName",
                      label: "First Name",
                      required: false,
                    },
                    {
                      id: "lastName",
                      label: "Last Name",
                      required: false,
                    }
                  ].map(({ id, label, required }) => (
                    <FormInput
                      key={id}
                      id={id}
                      label={label}
                      type="text"
                      disabled={true}
                      value={PatientRegistrationFormData[id]}
                      onChange={handleInputChange}
                      invalid={invalidFields.includes(label) && !PatientRegistrationFormData[id]}
                      required={required}
                    />
                  ))}
                </div>

                <div className="my-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <FormInput
                    key='date'
                    id='date'
                    label='Date'
                    type="text"
                    disabled={true}
                    value={formattedDate}
                    onChange={handleInputChange}
                    invalid={false}
                    required={false}
                  />

                </div>
              </div>
            </div>
          )}
        </form>

        <ButtonGroup
          isDisabled={isDisabled}
          currentPage={currentPage}
          handleEdit={handleEdit}
          handleNext={handleNext}
          handleSubmit={handleSubmit}
          handlePatientRegistration={handlePatientRegistration}
        />
      </div>
    </div>

  );
};

export default PatientRegistrationPageForm;
